"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Geometry = require("./Geometry");
/**
 * Returns the element position relative to the origin of the layout viewport.
 */
function getElementPositionRelativeToLayoutViewport(element) {
    return element.getBoundingClientRect();
}
exports.getElementPositionRelativeToLayoutViewport = getElementPositionRelativeToLayoutViewport;
/**
 * Returns the position of the layout viewport relative to the origin of the page.
 */
function getLayoutViewportPositionRelativeToPage() {
    var documentClientRect = document.documentElement.getBoundingClientRect();
    return { top: -documentClientRect.top, left: -documentClientRect.left };
}
exports.getLayoutViewportPositionRelativeToPage = getLayoutViewportPositionRelativeToPage;
/**
 * Returns the size of the layout viewport.
 */
function getLayoutViewportSize() {
    return { width: document.documentElement.clientWidth, height: document.documentElement.clientHeight };
}
exports.getLayoutViewportSize = getLayoutViewportSize;
/**
 * Returns the rectangle representing the visual viewport in the layout viewport's coordinate system.
 * For browsers that do not support the visual viewport API, the rectangle will include the space taken
 * by scroll bars if present.
 */
function getVisualViewportRectRelativeToLayoutViewport() {
    var visualViewport = getVisualViewport();
    var pos = {
        left: visualViewport.offsetLeft,
        top: visualViewport.offsetTop
    };
    var size = {
        width: visualViewport.width,
        height: visualViewport.height
    };
    return Geometry.makeClientRect(pos, size);
}
exports.getVisualViewportRectRelativeToLayoutViewport = getVisualViewportRectRelativeToLayoutViewport;
var VisualViewportPolyfill = /** @class */ (function () {
    function VisualViewportPolyfill() {
    }
    Object.defineProperty(VisualViewportPolyfill.prototype, "offsetLeft", {
        get: function () {
            var layoutPosInPageCoords = getLayoutViewportPositionRelativeToPage();
            return window.pageXOffset - layoutPosInPageCoords.left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualViewportPolyfill.prototype, "offsetTop", {
        get: function () {
            var layoutPosInPageCoords = getLayoutViewportPositionRelativeToPage();
            return window.pageYOffset - layoutPosInPageCoords.top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualViewportPolyfill.prototype, "pageLeft", {
        get: function () {
            return window.pageXOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualViewportPolyfill.prototype, "pageTop", {
        get: function () {
            return window.pageYOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualViewportPolyfill.prototype, "width", {
        // This polyfill doesn't work perfectly -- it will include the space taken by scroll bars if present
        get: function () {
            return window.innerWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualViewportPolyfill.prototype, "height", {
        // This polyfill doesn't work perfectly -- it will include the space taken by scroll bars if present
        get: function () {
            return window.innerHeight;
        },
        enumerable: true,
        configurable: true
    });
    return VisualViewportPolyfill;
}());
/**
 * Returns window.visualViewport if the API is available, otherwise returns our polyfill.
 * Note that this only exposes the portion of the Visual Viewport API that we have polyfilled.
 * See https://github.com/WICG/ViewportAPI for details on the Visual Viewport API.
 */
function getVisualViewport() {
    // tslint:disable-next-line:no-any
    return ('visualViewport' in window) ? window.visualViewport : new VisualViewportPolyfill();
}
exports.getVisualViewport = getVisualViewport;
//# sourceMappingURL=ViewportHelpers.js.map